import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';

const Pin = styled.img.withConfig({ componentId: 'sc-1frowab-0' })`
  height: 20px;
  width: 20px;
`;

type Props = {
  className?: string;
};

export default class CostEstimatePin extends PureComponent<Props> {
  render = () => (
    <Pin
      alt="Map pin"
      className={this.props.className}
      src="/images/cost_estimate/Icon-Map-POI-1x.png"
    />
  );
}
